import React, { useState, useEffect } from "react";
import Logo from "../../Logo";
import { StyledCardHeader } from "./style";
import { useSelector, useDispatch } from "react-redux";

function CardHeader() {
  const [activeDeactive, setActiveDeactive] = useState("Deactive");
  const { projectNamePoolName } =
    useSelector((state) => state.global);
  const { endBlock, currentBlockNO } = useSelector(
    (state) => state.global.poolDetailsFromFactory
  );

  useEffect(() => {
    if (currentBlockNO && endBlock) {
      if (Number(currentBlockNO) > Number(endBlock)) {
        setActiveDeactive("Deactive")
      } else {
        setActiveDeactive("Active")
      }
    }
  }, [currentBlockNO, endBlock]);

  return (
    <StyledCardHeader>
      <Logo small={false} />
      <div className="detailsWrap">
        <div className="nameWrap">
          <h1 className="projectName title">
            {projectNamePoolName?.project_name
              ? projectNamePoolName?.project_name
              : ""}
          </h1>
          <p className="desc">
            {projectNamePoolName?.pool_name
              ? projectNamePoolName?.pool_name
              : ""}
          </p>
        </div>
        <div className="status">
          <div className="pulse"></div>
          <p>{`${activeDeactive}`}</p>
        </div>
      </div>
    </StyledCardHeader>
  );
}

export default CardHeader;
